"use strict";

module.exports = {
    "copyright": {
        "link": "<i18n:param>content</i18n:param>",
        "yandex": "Yandex"
    }
};